import { DateFormat } from './dateFormats';
import { formatDate } from './formatDate';
import { parseDate } from './parseDate';

/**
 * Returns midnight of the given date in the bank's timezone.
 *
 * Use this when you need to compare against a GDS datepicker value — the datepicker
 * always passes midnight in bank timezone to `isOutsideRange`.
 *
 * @param date - any Date object
 */
export function startOfDayInBankTimezone(date: Date): Date {
    return parseDate(formatDate(date, DateFormat.ISO_DATE_FORMAT))!;
}

/**
 * Returns midnight of today in the bank's timezone.
 *
 * Equivalent to `startOfDayInBankTimezone(new Date())`.
 */
export function startOfTodayInBankTimezone(): Date {
    return startOfDayInBankTimezone(new Date());
}
